import * as React from 'react';
export const cancelSvg = React.forwardRef(function cancelSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M.72.72a.75.75 0 0 1 1.06 0L4 2.94 6.22.72a.75.75 0 0 1 1.06 1.06L5.06 4l2.22 2.22a.75.75 0 0 1-1.06 1.06L4 5.06 1.78 7.28A.75.75 0 0 1 .72 6.22L2.94 4 .72 1.78a.75.75 0 0 1 0-1.06Z',
    }),
  );
});
cancelSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cancel = {
  category: 'icon',
  colorable: true,
  name: 'cancel',
  svg: cancelSvg,
};
